
import horzintalLine from '../Images/horzintalLine.png'
import config from "../config.json";

import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import Services from "../Services/Services";
import { toast } from "react-toastify";
import phone from '../Images/phone2.png'
import instagram from '../Images/instagram2.png'
import telegram from '../Images/telegram2.png'
import sms from '../Images/sms2.png'



import whatsapp from '../Images/whatsapp.png'
import eita from '../Images/Eitaa.png'
import baleh from '../Images/bale.png'


export default function QrCodeAll({ data,code }) {
    const [form, setForm] = useState({ price: 0 })
    useEffect(() => {
        if (!data)
            return
        setForm(data.payload)
    }, [data]);

    const CreateIcon = ({ link, pic, caption }) => {
        return (
            <div className="col col-md col-5  ">
                <div className='row'>
                    <div className='col  d-flex  justify-content-center text-center '>
                        <a href={link} className="   text-decoration-none  align-middle ">
                            <img src={pic} className="imgIcon2" />
                        </a>
                    </div>
                </div>
                <div className='row py-0 my-0'>
                    <div className='col d-flex  justify-content-center text-center '>
                        <span className="text-white">{caption}</span>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <> 
            {'price' in form && form.price > 0 &&
                <div className="row  mt-3 pt-4">
                    <div className="col "  >
                        <span className=' text-white '>مژدگانی : </span>
                        <span className='text-danger'>{`${form.price}تومان`}</span>
                    </div>
                </div>
            }

            <div className="row mt-3 ">
                <div className="col d-flex justify-content-center fs-4 ">
                    <span className="text-white">راه های ارتباط با مالک</span>
                </div>
            </div>

            <div className="row p-0  ">
                <div className='col p-0 d-flex justify-content-center'>
                    <img src={horzintalLine} />
                </div>
            </div>
            <div className="row mt-3 mb-4 p-3" id="rowIcon2">
                {form.showData &&
                    <CreateIcon link={`tel:${form.number1}`} pic={phone} caption="تماس" />}

                {'telegram' in form && form.telegram != "" &&
                    <CreateIcon link={`https://t.me/${form.telegram}`} pic={telegram} caption="تلگرام" />}



                {'whatsapp' in form && form.eita != "" &&
                    <CreateIcon link={`https://wa.me/${http.checkNumber(form.whatsapp)}`} pic={whatsapp} caption="واتس آپ" />}


                {'eita' in form && form.eita != "" &&
                    <CreateIcon link={`https://eitaa.com/${form.eita}`} pic={eita} caption="ایتا" />}

                {'baleh' in form && form.baleh != "" &&
                    <CreateIcon link={`https://ble.ir/${form.baleh}`} pic={baleh} caption="بله" />}

                {'instagram' in form && form.instagram != "" &&
                    <CreateIcon link={`https://instagram.com/${form.instagram}`} pic={instagram} caption="اینستاگرام" />}

                <div className="col col-md col-5  ">
                    <div className='row'>
                        <div className='col  d-flex  justify-content-center text-center '>
                            {form.showData ?
                                (
                                    <a className="ff text-decoration-none" href={`sms:${form.number1};?&amp;body=سلام من شئ با مشخصات شما  ${form.displayName}  را پیدا کرده ام لطفا با من تماس بگیرید `}>
                                        <img src={sms} className="imgIcon2" />
                                    </a>
                                ) :
                                (<Link className="ff text-decoration-none"
                                    to="/"
                                    onClick={e => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        http.sendSms("100090300", code)
                                    }}
                                >
                                    <img src={sms} className="imgIcon2" />
                                </Link>)}
                        </div>
                    </div>
                    <div className='row py-0 my-0'>
                        <div className='col d-flex  justify-content-center text-center '>
                            <span className="text-white">پیامک</span>
                        </div>
                    </div>
                </div>
            </div>






        </>

    );

}
